/**
 * Transforms Ferguson API URLs for lightbox display.
 * If the URL is from api.ferguson.com and contains STANDARD_IMAGE,
 * it removes the ASSET_ID parameter and changes USE_TYPE to ZOOM_IMAGE.
 */
export const transformFergusonImageUrl = (
    url: string | null | undefined,
): string | null | undefined => {
    if (!url) {
        return url;
    }

    try {
        const urlObj = new URL(url);

        // Check if it's a Ferguson API URL
        if (urlObj.hostname !== 'api.ferguson.com') {
            return url;
        }

        // Check if it contains STANDARD_IMAGE
        const searchParams = urlObj.searchParams;
        const useType = searchParams.get('USE_TYPE');

        if (useType !== 'STANDARD_IMAGE') {
            return url;
        }

        // Remove ASSET_ID parameter
        searchParams.delete('ASSET_ID');

        // Replace USE_TYPE with ZOOM_IMAGE
        searchParams.set('USE_TYPE', 'ZOOM_IMAGE');

        // Return the transformed URL
        return urlObj.toString();
    } catch {
        return url;
    }
};
